import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePickerCustomComponent } from './date-picker-custom.component';
import { MaterialModule } from "../../material/material.module";
import { OverlayModule } from '@angular/cdk/overlay';



@NgModule({
  declarations: [
    DatePickerCustomComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    OverlayModule
],
exports:[
  DatePickerCustomComponent
]
})
export class DatePickerCustomModule { }
